import Vue from 'vue';

const query = window.matchMedia('(max-width: 1024px)');
const compactQuery = window.matchMedia('(max-width: 480px)');
const mobile = Vue.observable({ active: query.matches, compact: compactQuery.matches });
const update = (event) => { mobile.active = event.matches; };
if (query.addEventListener) {
    query.addEventListener('change', update);
} else {
    query.addListener(update);
}
const updateCompact = (event) => { mobile.compact = event.matches; };
if (compactQuery.addEventListener) {
    compactQuery.addEventListener('change', updateCompact);
} else {
    compactQuery.addListener(updateCompact);
}

export default mobile;
